import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import vAdminformat from "../adminFormat";
import { Link } from 'react-router-dom';
import config from '../config';
import { headers } from '../token';
import validateError from '../ValidateError';


const server_backend = config.API_URL;

const MetalsPriceApi = () => {

    const [lastCode, SetLastCode] = useState([]);
    const [authXeroModal, setAutXeroModal] = useState(false);


    const startProcess = async () => {

        try {
            const response = await axios.post(`${server_backend}/materials/types/start`, {}, headers);
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: response.data.RES_MESSAGE,
                confirmButtonText: 'Ok'
            });
            console.log(response.data);

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response.data.RES_MESSAGE,
                confirmButtonText: 'Ok'
            });

            console.log(error);
        }

    };

    const stopProcess = async () => {
        try {
            const response = await axios.post(`${server_backend}/materials/types/stop`, {}, headers);
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: response.data.RES_MESSAGE,
                confirmButtonText: 'Ok'
            });
            console.log(response.data);

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response.data.RES_MESSAGE,
                confirmButtonText: 'Ok'
            });

            console.log(error);
        }
    };

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>

            <div className="card">
                <div className="card-header text-white text-center">
                    <h4 className=''>Automated Metal Price Update</h4>
                </div>
                <div className="card-body">
                    <p className="text-muted">
                        This system automatically updates metal prices twice a day using real-time data from our pricing API.
                        You can manually enable or disable this process as needed.
                    </p>
                    <div className="alert alert-info">
                        <h6 className="fw-bold">How It Works:</h6>
                        <ul className="mb-0">
                            <li>When <strong>enabled</strong>, the system fetches and updates prices automatically.</li>
                            <li>When <strong>disabled</strong>, price updates will be paused until reactivated.</li>
                            <li>When generating a <strong>quotation</strong> or <strong>order</strong>, the system will use the latest available prices retrieved by this process.</li>
                        </ul>
                    </div>
                    <div className="alert alert-warning">
                        <h6 className="fw-bold">Note:</h6>
                        <p className="mb-0">
                            Two sections have been added under the **Metrics** menu:
                            <ul>
                                <li><strong>Daily Metal Fix</strong>: Displays the latest metal prices in GBP, including the last update date.</li>
                                <li><strong>API Metal Price</strong>: Provides a historical view of metal prices in multiple currencies.</li>
                            </ul>
                        </p>
                    </div>
                    <div className="alert alert-secondary">
                        <h6 className="fw-bold">Pricing in Orders & Quotations:</h6>
                        <p className="mb-0">
                            Every time an order or quotation is created, the system will automatically reference the most recent
                            metal prices retrieved by this process, ensuring accurate and up-to-date pricing.
                        </p>
                    </div>
                    <div className="d-flex justify-content-center gap-3">
                        <button type="button" className="btn btn-danger " onClick={stopProcess}>
                            <i className="fas fa-stop-circle"></i> Stop Price Updates
                        </button>
                        <button type="button" className="btn btn-success " onClick={startProcess}>
                            <i className="fas fa-play-circle"></i> Start Price Updates
                        </button>
                    </div>
                </div>
            </div>



        </div>
    );
};

export default MetalsPriceApi;
